import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import {
  TSportingStatusHistoryItem,
  SportingSecureParams
} from 'services/sporting/types';
import { createQueryString } from 'utils/createQueryString';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

type Payload = {
  idParticipation: number;
};

export const getParticipationStatusHistory = async (
  params: SportingSecureParams<Payload>
): Promise<TSportingStatusHistoryItem[]> => {
  const { payload } = params;

  const endpointURL = getSportingServiceURL(
    `getParticipationStatusHistory?${createQueryString(payload)}`
  );

  const headers = createSportingHeaders();

  const response = await customFetch(endpointURL, { headers });

  if (response.ok) {
    return response.json();
  } else {
    throw new UnexpectedError();
  }
};
